
/* injects from baggage-loader */

'use strict';

import config from './index.config';
import run from './index.run';

import uiRouter from '@uirouter/angularjs';

import coreModule from './core/core.module';
import indexComponents from './index.components';
import indexRoutes from './index.routes';
import loginModule from './pages/login/login.module';
import mainModule from './pages/main/main.module';
import stageOneModule from './pages/stage-one/stage-one.module';
import stageTwoModule from './pages/stage-two/stage-two.module';
import stageThreePageModule from './pages/stage-three/stage-three.module';
import stageFourPageModule from './pages/stage-four/stage-four.module';
// import stageFifthPageModule from './pages/stage-fifth/stage-fifth.module';
// import stageSixthPageModule from './pages/stage-sixth/stage-sixth.module';
// // import stageSeventhPageModule from './pages/stage-seventh/stage-seventh.module';


const App = angular.module(
  "template", [
    // plugins
    uiRouter,
    "ngAnimate", 
    "ngCookies", 
    "ngTouch", 
    "ngSanitize", 
    "ngMessages", 
    "ngAria",
    "ngMask",
    "ng-sortable",
    "ang-drag-drop",
    "cfp.hotkeys",
    "ui.bootstrap",
    "ui.validate",

    // core
    coreModule.name,

    // components
    indexComponents.name,

    // routes

    indexRoutes.name,
    // pages
    loginModule.name,
    mainModule.name,
    stageOneModule.name,
    stageTwoModule.name,
    stageThreePageModule.name,
    stageFourPageModule.name,
    // stageFifthPageModule.name,
    // stageSixthPageModule.name,
    // stageSeventhPageModule.name,
  ]
);

App
  .config(config)
  .run(run);



export default App;



// WEBPACK FOOTER //
// ./src/app/index.module.js